import { Field, useField } from "formik";
import React, { useRef } from "react";
import AppTextarea, { AppTextareaProps } from "src/commun/composants/formulaire/AppTextarea/AppTextarea";
import useScrollToError from "src/commun/composants/formulaire/formik/hooks/useScrollToError";

export type AppTextareaFormikProps = Omit<AppTextareaProps, "onChange" | "value" | "error"> & {
  formulaireSoumis?: boolean;
};

const AppTextareaFormik = ({ name, formulaireSoumis = false, isRequired = true,...reste }: AppTextareaFormikProps) => {
  const [, { error, touched }] = useField(name);
  const ref = useRef(undefined);
  useScrollToError(name, ref);

  return <Field fieldRef={ref} name={name} error={error} touched={formulaireSoumis || touched} as={AppTextarea} isRequired={isRequired} {...reste} />;
};

export default AppTextareaFormik;
